import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { auth } from "./firebase"; // Import the Firebase auth object
import { UserProvider } from "./contexts/UserContext";
import MenuBar from "./menuBar";
import Login from "./login";
import Home from "./home";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import EmailVerification from "./pages/EmailVerification";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Subscription from "./pages/Subscription";
import OAuthAuthorize from "./pages/OAuthAuthorize";
import { Spinner } from "react-bootstrap";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <Spinner animation="border" />;
  }

  return (
    <UserProvider>
      <Router>
        <MenuBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/oauth/authorize" element={<OAuthAuthorize />} />
          {user ? (
            <>
              <Route path="/subscription" element={<Subscription />} />
            </>
          ) : (
            <></>
          )}
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
